// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "ccabdd864de8ea1aeb7a" + ".chunk.js";
};